// HKDSE Type F (戲曲) Quiz Data
// 系統化分類測驗數據，為後續 Supabase 後端數據遷移做準備

const hkdseTypeFQuizData = {
  // F1: 唐詩《三州》
  'hkdse-f1-tangshi-sanzhou': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'f1-kp-1',
          question: '《竇娥冤》的核心主題是什麼？',
          options: [
            'A. 愛情悲劇',
            'B. 社會不公',
            'C. 人性善惡',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '戲曲表達了愛情悲劇、社會不公和人性善惡等多重主題。',
          points: 10
        },
        {
          id: 'f1-kp-2',
          question: '竇娥的悲劇反映了什麼？',
          options: [
            'A. 個人命運',
            'B. 社會黑暗',
            'C. 制度缺陷',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '竇娥的悲劇反映了個人命運、社會黑暗和制度缺陷。',
          points: 10
        },
        {
          id: 'f1-kp-3',
          question: '關漢卿如何表達對社會的批判？',
          options: [
            'A. 直接批判',
            'B. 通過情節',
            'C. 通過人物',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '關漢卿通過直接批判、情節安排和人物塑造來表達對社會的批判。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'f1-am-1',
          question: '戲曲如何論證「社會不公」？',
          options: [
            'A. 通過對比',
            'B. 通過比喻',
            'C. 通過舉例',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '戲曲通過對比竇娥的善良與社會的黑暗來論證社會不公。',
          points: 10
        },
        {
          id: 'f1-am-2',
          question: '關漢卿如何突出竇娥的悲劇性？',
          options: [
            'A. 直接描述',
            'B. 通過對比',
            'C. 通過比喻',
            'D. 通過誇張'
          ],
          correctAnswer: 'B',
          explanation: '關漢卿通過對比竇娥的善良與她的悲慘遭遇來突出悲劇性。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'f1-wt-1',
          question: '戲曲的結構特點是什麼？',
          options: [
            'A. 四折一楔子',
            'B. 起承轉合',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '戲曲採用四折一楔子的結構，符合元雜劇的傳統格式。',
          points: 10
        },
        {
          id: 'f1-wt-2',
          question: '戲曲的語言特色是什麼？',
          options: [
            'A. 樸實通俗',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'A',
          explanation: '戲曲語言樸實通俗，便於觀眾理解。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'f1-rd-1',
          question: '「六月飛雪」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 對偶',
            'D. 擬人'
          ],
          correctAnswer: 'B',
          explanation: '這句話運用了誇張修辭，突出了竇娥冤情的深重。',
          points: 10
        },
        {
          id: 'f1-rd-2',
          question: '戲曲中的對白有什麼作用？',
          options: [
            'A. 推動情節',
            'B. 展現性格',
            'C. 表達情感',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '對白既能推動情節，又能展現性格，還能表達情感。',
          points: 10
        }
      ]
    }
  },

  // F2: 宋詞《三州》
  'hkdse-f2-ci-sanzhou': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'f2-kp-1',
          question: '《牡丹亭》的核心主題是什麼？',
          options: [
            'A. 愛情自由',
            'B. 人性解放',
            'C. 生死輪迴',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '戲曲表達了愛情自由、人性解放和生死輪迴等多重主題。',
          points: 10
        },
        {
          id: 'f2-kp-2',
          question: '杜麗娘的形象代表了什麼？',
          options: [
            'A. 愛情理想',
            'B. 人性解放',
            'C. 反抗精神',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '杜麗娘代表了愛情理想、人性解放和反抗精神。',
          points: 10
        },
        {
          id: 'f2-kp-3',
          question: '湯顯祖如何表達對愛情的讚美？',
          options: [
            'A. 直接抒情',
            'B. 通過情節',
            'C. 通過人物',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '湯顯祖通過直接抒情、情節安排和人物塑造來讚美愛情。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'f2-am-1',
          question: '戲曲如何論證「愛情的力量」？',
          options: [
            'A. 通過對比',
            'B. 通過比喻',
            'C. 通過舉例',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '戲曲通過對比生死來論證愛情的力量。',
          points: 10
        },
        {
          id: 'f2-am-2',
          question: '湯顯祖如何突出愛情的純潔？',
          options: [
            'A. 直接描述',
            'B. 通過對比',
            'C. 通過比喻',
            'D. 通過誇張'
          ],
          correctAnswer: 'B',
          explanation: '湯顯祖通過對比世俗與純潔來突出愛情的純潔。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'f2-wt-1',
          question: '戲曲的結構特點是什麼？',
          options: [
            'A. 五十五齣',
            'B. 起承轉合',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '戲曲採用五十五齣的結構，規模宏大。',
          points: 10
        },
        {
          id: 'f2-wt-2',
          question: '戲曲的語言特色是什麼？',
          options: [
            'A. 樸實通俗',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'B',
          explanation: '戲曲語言華麗典雅，體現了湯顯祖的藝術風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'f2-rd-1',
          question: '「良辰美景奈何天」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 對偶',
            'D. 設問'
          ],
          correctAnswer: 'C',
          explanation: '這句話運用了對偶修辭，結構工整。',
          points: 10
        },
        {
          id: 'f2-rd-2',
          question: '戲曲中的唱詞有什麼作用？',
          options: [
            'A. 表達情感',
            'B. 推動情節',
            'C. 展現性格',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '唱詞既能表達情感，又能推動情節，還能展現性格。',
          points: 10
        }
      ]
    }
  },

  // F3: 孔尚任《桃花扇》
  'hkdse-f3-kongshangren-taohuashan': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'f3-kp-1',
          question: '《桃花扇》的核心主題是什麼？',
          options: [
            'A. 愛情悲劇',
            'B. 歷史興衰',
            'C. 政治鬥爭',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '戲曲表達了愛情悲劇、歷史興衰和政治鬥爭等多重主題。',
          points: 10
        },
        {
          id: 'f3-kp-2',
          question: '李香君的形象代表了什麼？',
          options: [
            'A. 愛情忠貞',
            'B. 民族氣節',
            'C. 反抗精神',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '李香君代表了愛情忠貞、民族氣節和反抗精神。',
          points: 10
        },
        {
          id: 'f3-kp-3',
          question: '孔尚任如何表達對歷史的反思？',
          options: [
            'A. 直接評論',
            'B. 通過情節',
            'C. 通過人物',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '孔尚任通過直接評論、情節安排和人物塑造來反思歷史。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'f3-am-1',
          question: '戲曲如何論證「歷史興衰」？',
          options: [
            'A. 通過對比',
            'B. 通過比喻',
            'C. 通過舉例',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '戲曲通過對比南明王朝的興衰來論證歷史規律。',
          points: 10
        },
        {
          id: 'f3-am-2',
          question: '孔尚任如何突出愛情的悲劇性？',
          options: [
            'A. 直接描述',
            'B. 通過對比',
            'C. 通過比喻',
            'D. 通過誇張'
          ],
          correctAnswer: 'B',
          explanation: '孔尚任通過對比愛情的純潔與政治的殘酷來突出悲劇性。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'f3-wt-1',
          question: '戲曲的結構特點是什麼？',
          options: [
            'A. 四十四齣',
            'B. 起承轉合',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '戲曲採用四十四齣的結構，規模宏大。',
          points: 10
        },
        {
          id: 'f3-wt-2',
          question: '戲曲的語言特色是什麼？',
          options: [
            'A. 樸實通俗',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'B',
          explanation: '戲曲語言華麗典雅，體現了孔尚任的藝術風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'f3-rd-1',
          question: '「桃花扇底送南朝」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 對偶',
            'D. 借代'
          ],
          correctAnswer: 'D',
          explanation: '這句話運用了借代修辭，用桃花扇借代愛情。',
          points: 10
        },
        {
          id: 'f3-rd-2',
          question: '戲曲中的道具有什麼作用？',
          options: [
            'A. 推動情節',
            'B. 象徵意義',
            'C. 增強效果',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '道具既能推動情節，又能象徵意義，還能增強效果。',
          points: 10
        }
      ]
    }
  }
};

// Helper functions
export const getTypeFQuizData = () => {
  return hkdseTypeFQuizData;
};

export const getTypeFQuizByType = (textId, categoryType) => {
  const quizData = hkdseTypeFQuizData[textId];
  if (!quizData) return null;

  const categoryData = quizData[categoryType];
  if (!categoryData) return null;

  // Convert questions to match the expected format
  const convertedQuestions = categoryData.questions.map(question => ({
    ...question,
    correct: question.correctAnswer.charCodeAt(0) - 65, // Convert 'A' to 0, 'B' to 1, etc.
    type: 'multiple-choice'
  }));

  return {
    title: categoryData.title,
    questions: convertedQuestions,
    timeLimit: 300, // 5 minutes
    totalPoints: categoryData.questions.reduce((sum, q) => sum + q.points, 0)
  };
};

export default hkdseTypeFQuizData;
